import * as React from 'react';
import { trackPageView } from '../utils/analytics'
import { useLocation } from 'react-router-dom';

export default function RouteTracker({ measurementId }) {
  const location = useLocation()

  React.useEffect(() => {
    if (measurementId) {
      const path = location.pathname + location.search + location.hash
      trackPageView(measurementId, path)
    }
  }, [location, measurementId])

  return null
}
